import { IconProps } from "./types";

export const IconlyDocumentPencil = ({
  size = 24,
  color = "currentColor",
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.7698 10.2983V8.9984C18.7698 8.47008 18.5655 7.96121 18.1987 7.57884L14.407 3.62955C14.0207 3.22674 13.4866 3.00004 12.929 3.00004H7.27705C5.23673 2.99128 3.56517 4.61711 3.51652 6.65646V17.1636C3.47176 19.236 5.11414 20.9533 7.18657 20.999C7.21673 20.999 11.1894 21 11.1894 21"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.4121 3.0625V5.95514C13.4111 7.36692 14.5544 8.51211 15.9662 8.51503H18.7051"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.546 14.1089H7.81736M10.2848 9.98047H7.81641"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4366 14.1181C17.7283 13.6128 18.3745 13.4396 18.8798 13.7314L19.659 14.1812C20.1643 14.473 20.3375 15.1192 20.0457 15.6245L17.6176 19.83C17.3846 20.2336 17.0129 20.5387 16.5717 20.6885L15.9224 20.9089C15.4828 21.0582 15.0123 20.7865 14.9217 20.3312L14.788 19.6587C14.6972 19.2017 14.7755 18.7272 15.0085 18.3236L17.4366 14.1181Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
